import React from 'react';
import ImageGallery from '../components/ImageGallery';
import SEOHeadNative from '../components/SEOHeadNative';

const MaintenanceIndustrielle: React.FC = () => {
  const galleryImages = [
    {
      src: '/images/maintenance/armoire-electrique.jpg',
      title: 'Maintenance armoires électriques',
      description: 'Contrôle et maintenance d\'armoires électriques industrielles'
    },
    {
      src: '/images/maintenance/moteur-industriel.jpg',
      title: 'Maintenance moteurs',
      description: 'Révision et réparation de moteurs électriques industriels'
    },
    {
      src: '/images/maintenance/automate.jpg',
      title: 'Programmation automates',
      description: 'Maintenance et programmation d\'automates industriels'
    },
    {
      src: '/images/maintenance/tableau-commande.jpg',
      title: 'Tableaux de commande',
      description: 'Maintenance préventive et curative des tableaux'
    },
    {
      src: '/images/maintenance/intervention-usine.jpg',
      title: 'Interventions en usine',
      description: 'Dépannages urgents et maintenance planifiée'
    },
    {
      src: '/images/maintenance/controle-installation.jpg',
      title: 'Contrôles périodiques',
      description: 'Vérifications réglementaires et diagnostics'
    }
  ];

  return (
    <div>
      <SEOHeadNative
        title="Maintenance Industrielle - OZARKS ELEC"
        description="Maintenance électrique industrielle à Viesly. Dépannage urgent, maintenance préventive, contrôles périodiques. Intervention dans l'Aisne, Thiérache et région Nord."
        keywords="maintenance industrielle Viesly, dépannage électrique industrie, maintenance préventive Aisne, contrôle installation électrique, électricien industriel Nord"
        canonical="/maintenindus"
        structuredData={{
          "@context": "https://schema.org",
          "@type": "Service",
          "name": "Maintenance Industrielle",
          "description": "Maintenance électrique industrielle : dépannage urgent, maintenance préventive et curative, contrôles périodiques.",
          "provider": {
            "@type": "ElectricalContractor",
            "name": "OZARKS ELEC",
            "url": "https://ozarkselec.com"
          },
          "areaServed": ["Aisne", "Thiérache", "Caudrésis", "Catésis", "Nord"],
          "serviceType": "Maintenance industrielle"
        }}
      />
      <div className="r t-rec t-rec_pt_90 t-rec_pb_90" style={{paddingTop: '90px', paddingBottom: '90px'}}>
        <div className="t-container">
          <div className="t-col t-col_8 t-prefix_2">
            <div className="t-align_center">
              <h1 className="t-title t-title_xs ozarks-blue-dark">
                Maintenance <span className="ozarks-blue-medium">Industrielle</span>
              </h1>
              
              <div style={{marginTop: '60px', textAlign: 'left'}}>
                <div style={{marginBottom: '40px'}}>
                  <h3 className="ozarks-blue-dark" style={{marginBottom: '15px', fontWeight: 600}}>🔧 Maintenance préventive</h3>
                  <p className="ozarks-gray" style={{lineHeight: '1.7'}}>
                    Programmes de maintenance planifiée pour optimiser la disponibilité de vos équipements. 
                    Contrôles périodiques, vérifications réglementaires et diagnostics préventifs.
                  </p>
                </div>

                <div style={{marginBottom: '40px'}}>
                  <h3 className="ozarks-blue-dark" style={{marginBottom: '15px', fontWeight: 600}}>⚡ Dépannage d'urgence</h3>
                  <p className="ozarks-gray" style={{lineHeight: '1.7'}}>
                    Intervention rapide 24h/7j pour minimiser les arrêts de production. 
                    Diagnostic précis et réparation efficace de vos installations électriques industrielles.
                  </p>
                </div>

                <div style={{marginBottom: '40px'}}>
                  <h3 className="ozarks-blue-dark" style={{marginBottom: '15px', fontWeight: 600}}>🤖 Automatismes industriels</h3>
                  <p className="ozarks-gray" style={{lineHeight: '1.7'}}>
                    Maintenance et programmation d'automates, variateurs de vitesse et systèmes de contrôle. 
                    Modernisation d'installations existantes pour améliorer les performances.
                  </p>
                </div>

                <div style={{marginBottom: '40px'}}>
                  <h3 className="ozarks-blue-dark" style={{marginBottom: '15px', fontWeight: 600}}>📊 Suivi et reporting</h3>
                  <p className="ozarks-gray" style={{lineHeight: '1.7'}}>
                    Tableaux de bord et rapports détaillés de maintenance. 
                    Traçabilité des interventions et recommandations pour optimiser vos installations.
                  </p>
                </div>

                <div style={{backgroundColor: 'var(--ozarks-light-gray)', padding: '20px', borderRadius: '10px', marginTop: '40px'}}>
                  <h4 className="ozarks-blue-dark" style={{marginBottom: '15px'}}>🏭 Expertise industrielle</h4>
                  <p className="ozarks-gray" style={{lineHeight: '1.7', marginBottom: '0'}}>
                    <strong>Spécialistes de l'électricité industrielle</strong> avec une connaissance approfondie 
                    des contraintes de production. Respect des normes de sécurité et de qualité industrielles.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Galerie interactive de réalisations */}
      <div className="r t-rec t-rec_pt_60 t-rec_pb_60" style={{paddingTop: '60px', paddingBottom: '60px', backgroundColor: 'var(--ozarks-light-gray)'}}>
        <div className="t-container">
          <div className="t-col t-col_12">
            <div className="t-section__title t-title t-title_xs t-align_center t-margin_auto">
              <div style={{fontSize: '32px'}} className="ozarks-blue-dark">
                Galerie de nos <span className="ozarks-blue-medium">interventions</span>
              </div>
              <div className="t-descr t-descr_xl t-margin_auto" style={{marginTop: '15px', color: 'var(--ozarks-gray)', maxWidth: '600px'}}>
                Découvrez nos interventions en maintenance industrielle. 
                Cliquez sur les images pour les voir en grand format.
              </div>
            </div>
            
            <ImageGallery images={galleryImages} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default MaintenanceIndustrielle;